import { Icon, IconProps } from '@frontend/design-system';
import { theme } from '@frontend/theme';

type Props = IconProps & {
  rating: number;
};

export const FacebookLegacyRatingIcon = ({ rating, ...props }: Props) => {
  return (
    <Icon viewBox={'0, 0, 32, 16'} width={32} height={16} {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8 0C3.582 0 0 3.582 0 8s3.582 8 8 8h16c4.418 0 8-3.582 8-8s-3.582-8-8-8H8zm12.529 3.833L19.35 6.21l-2.636.384c-.385.056-.538.53-.258.8L18.36 9.24l-.45 2.61c-.066.382.336.674.68.494l2.357-1.234 2.358 1.234c.344.18.745-.112.68-.495l-.45-2.609 1.905-1.847c.28-.27.127-.744-.258-.8l-2.636-.384-1.179-2.376c-.172-.347-.667-.347-.84 0z'
        fill='#146EF5'
      />

      <text fontFamily={theme.font.family} fontSize='12' fontWeight='normal' fill='#FFF'>
        <tspan x='6' y='12'>
          {rating}
        </tspan>
      </text>
    </Icon>
  );
};
